import { render, staticRenderFns } from "./SignUpImage.vue?vue&type=template&id=4b0f3ba4&scoped=true&"
import script from "./SignUpImage.vue?vue&type=script&lang=js&"
export * from "./SignUpImage.vue?vue&type=script&lang=js&"
import style0 from "./SignUpImage.vue?vue&type=style&index=0&id=4b0f3ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f3ba4",
  null
  
)

export default component.exports